
        <div class="Notifications">
            <div class="Notifications__Item" *ngIf="service.item | async" [ngClass]="{'Notifications--alert': !service.getItem().success, 'Notifications--success': service.getItem().success}">
                {{ service.getItem().message }}
                <button class="Notifications__ItemClose" (click)="handleClose()"><i class="mdi mdi-close"></i></button>
            </div>
        </div>
    